// extracted by mini-css-extract-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","item":"item-2hHth"};